import { format, isValid } from "date-fns";

export default (transaction_date) => {
  if (isValid(Number(transaction_date) * 1000)) {
    return format(
      new Date(Number(transaction_date) * 1000),
      "dd.MM.yyyy HH:mm"
    );
  } else {
    return "Не указано";
  }
};
